import React from 'react';
import Reflux from 'reflux';
import {Button, Row, Col, Modal, Radio, Select, Input, message} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice} from 'Utils';
import {objectSerial, config} from 'Utils';
import {getSalesList, list2} from '../../service/thingsOrder';
import moment from "moment/moment";

class SalesList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['销售明细报表'],
            key: 0,
            selectedRowKeys: [],
            selectedRows: [],
            rows: [],
            total: 1,
            searchObj: {
                payType: '',//付款
                code: '', // 编号
                productCode: '', // 物料编号
                cusId: '', // 客户名称
                orderDateStart: '', // 起
                orderDateEnd: '', // 止
                remark: '',
                s: 10,
                p: 1
            },
            visible: false,
            button_limits_end: {},
            loading: false,
            custList: '',
            sumAmount: 0,
            sumSaleAmount: 0,
            sumReceivedAmount: 0,
            sumCount: 0
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };


    /*筛选*/
    setFilterParam(name, value) {
        if (name === 'shipTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    orderDateStart: value.from,
                    orderDateEnd: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /*筛选重置*/
    advanceReset() {
        const self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                payType: '',//付款
                code: '', // 编号
                productCode: '', // 物料编号
                productDesc: '',//物料描述
                cusId: '', // 客户名称
                orderDateStart: '', // 起
                orderDateEnd: '', // 止
                remark: '',
                p: 0,
                s: 10,
            }, loading: false
        })
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        const self = this;
        var sObj = this.state.searchObj;
        this.setState({searchObj: {...this.state.searchObj, p: 1}, loading: true}, function () {
            self.initData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        var obj = this.state.searchObj;
        getSalesList(obj).then(result => {
            if (result.status) {
                this.setState({
                    rows: result.data || [],
                    total: result.total || 1,
                    loading: false,
                    sumAmount: 0,
                    sumSaleAmount: 0,
                    sumReceivedAmount: 0,
                    sumCount: 0
                })
                result.data.forEach(item => {
                    this.setState({
                        sumAmount: item.sumAmount,
                        sumSaleAmount: item.sumSaleAmount,
                        sumReceivedAmount: item.sumReceivedAmount,
                        sumCount: item.sumCount
                    })
                })
            } else {
                this.setState({
                    loading: false
                })
                message.error(result.message);
            }
        })
    }

    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({selectedRowKeys, selectedRows});
        // console.log()
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    edit(record) {
        this.goView(`/thingsOrder/edit/${record.id}`);
    }

    exportChange = () => {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/trans/order/exportExcel?${objectSerial(_searchObj)}`;
        window.open(url);
    }

    getList2(param) {
        list2(param).then((result) => { //获取客户管理
            if (result && result.code == 200) {
                let arr = [];
                arr.push({text: '全部', value: ''});
                result.data.forEach(item => {
                    arr.push({text: item.name, value: item.id});
                })
                this.setState({custList: arr});
            } else {
                openNotice('error', '获取数据失败', result.message || '');
            }
        });
    }

    componentDidMount() {
        //this.initData();
        //设置离开当前路由时的钩子函数
        this.getList2({p: 1, s: 10000});
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    render() {
        var self = this;
        const {
            opts,
            key,
            rows,
            total,
            selectedRowKeys,
            searchObj,
            visible,
            button_limits_end,
            loading,
            custList
        } = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'shipTime',//startCreatedDate, endCreatedDate
                    label: '订单日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.orderDateStart || '',
                        end: searchObj.orderDateEnd || ''
                    }
                },
                {
                    name: 'code',
                    label: '订单编号',
                    text: '输入订单编号',
                    type: 'default',
                    defaultValue: searchObj.code
                },
                {
                    name: 'productCode',
                    label: '物料编号',
                    text: '输入物料编号',
                    type: 'default',
                    defaultValue: searchObj.productCode
                },
                {
                    name: 'productDesc',
                    label: '物料描述',
                    text: '输入物料描述',
                    type: 'default',
                    defaultValue: searchObj.productDesc
                },
                {
                    name: 'cusId',
                    label: '客户名称',
                    text: '输入客户名称',
                    type: 'select',
                    options: custList,
                    showSearch: true,
                    defaultValue: searchObj.cusId
                },
                {
                    name: 'payType',
                    label: '收款',
                    text: '输入收款',
                    type: 'select',
                    defaultValue: searchObj.payType,
                    howSearch: true,
                    options: [{text: '全部', value: ''}, {text: '现金', value: '现金'}, {
                        text: '欠款',
                        value: '欠款'
                    }, {text: '代收', value: '代收'}, {text: '月结', value: '月结'}, {text: '银行', value: '银行'}, {
                        text: '转账',
                        value: '转账'
                    }, {text: '支付宝', value: '支付宝'}, {text: '微信', value: '微信'}],
                },
                {
                    name: 'remark',
                    label: '备注',
                    text: '输入备注',
                    type: 'default',
                    defaultValue: searchObj.remark
                }

            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '订单编号',
                    dataIndex: 'code',
                    width: '120px',
                }, {
                    title: '客户名称',
                    dataIndex: 'name'
                },
                {
                    title: '订单类型',
                    dataIndex: 'orderType'
                },
                {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                }, {
                    title: '物料描述',
                    dataIndex: 'itemDesc'
                }, {
                    title: '子库编码',
                    dataIndex: 'subStoreNumber'
                }, {
                    title: '子库名称',
                    dataIndex: 'subStoreName'
                }, {
                    title: '系列',
                    dataIndex: 'proType'
                }, {
                    title: '收款',
                    dataIndex: 'payType'
                }, {
                    title: '日期',
                    dataIndex: 'orderDate',
                    render: text => <span>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</span>
                }, {
                    title: '下浮%',
                    dataIndex: 'priceRate'
                }, {
                    title: '数量',
                    dataIndex: 'count'
                }, {
                    title: '发运数量',
                    dataIndex: 'shipCount'
                }, {
                    title: '销售单价',
                    dataIndex: 'unitPrice'
                }, {
                    title: '销售金额',
                    dataIndex: 'sumPrice'
                }, {
                    title: '整单折扣',
                    dataIndex: 'discountRate'
                }, {
                    title: '实收金额',
                    dataIndex: 'receivedAmount'
                }, {
                    title: '面价金额',
                    dataIndex: 'amount'
                }, {
                    title: '备注',
                    dataIndex: 'remark'
                }, {
                    title: '行备注',
                    dataIndex: 'lineRemark'
                }, {
                    title: '销售员',
                    dataIndex: 'businessName'
                }
            ],
            rows,
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}/>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <div>销售金额合计：{this.state.sumSaleAmount} 实收金额合计：{this.state.sumReceivedAmount} 牌价金额合计：{this.state.sumAmount} 数量合计：{this.state.sumCount}</div>
                    <Button style={{position: 'absolute', bottom: 8, right: 0}} icon="export"
                            onClick={this.exportChange.bind(this)}>导出</Button>
                </div>
                <TableView {...tableViewProps} />
            </div>
        </div>
    }
}
;
export default withRouter(SalesList);


// WEBPACK FOOTER //
// ./src/routes/thingsOrder/salesList.js